<template>
  <div class="audio-page">
    <div class="audio-page-body">
      <audio-player ref="audioPlay" :src="aduio_src" />
    </div>
  </div>
</template>

<script>
import audioPlayer from '@/components/audioplayer/index.vue'
export default {
  components: {
    audioPlayer
  },
  data() {
    return {
      aduio_src: ''
    }
  },
  created() {
    this.aduio_src = this.$route.query.src
  },
  methods: {
    filePath() {
      return ''
    }
  }
}
</script>

<style scoped>

  .audio-page {
    margin-top: -60px;
  }
  .audio-page-body {
    height: 400px;
  }
</style>
